/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { TextGlobal } from './text.Global';
import { useSelector } from 'react-redux';
import { getId } from '../../utils/item';

export const TextSortable = props => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: props.id });
  const { textId, itemId } = props;

  const item = useSelector(state => state.items[itemId]);

  const [text, setText] = useState({});

  useEffect(() => {
    if (item?.text) {
      const textObj = item.text.find(textObj => getId(textObj) === textId);
      if (textObj?.[textId]) {
        setText(textObj[textId]);
      }
    }
  }, [item?.text]);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={style}
      className={`m-1 flex flex-col justify-center items-center`}
    >
      <TextGlobal
        textId={textId}
        itemId={itemId}
        text={text}
      />
    </div>
  );
};
